<template>
  <v-dialog
    v-model="getModalCadastroOrdemServico"
    scrollable
    fullscreen
    persistent
    :overlay="false"
    transition="dialog-transition"
  >
    <v-card>
      <v-card-title
        >Cadastro de OS<v-spacer />
        <v-btn
          color="default"
          outlined
          @click="
            $store.dispatch('ativaModalConfirmacao', {
              mensagem:
                'Você perderá os dados que já preencheu caso não tenha salvo, deseja realmente voltar?',
              action: 'setModalCadastroOrdemServico',
              action_value: false,
            })
          "
          class="ml-1 mr-1"
          >Voltar</v-btn
        >
        <v-btn
          color="success"
          outlined
          class="ml-1 mr-1"
          @click="modalSalvarOrdemServico = true"
          v-if="
            exibeBotaoSalvar == true &&
              ($helper.verificaPermissao('cadastrar-ordem-servico') ||
                $helper.verificaPermissao('atualizar-ordem-servico'))
          "
          >Salvar</v-btn
        >
        <v-btn
          v-if="
            getOrdemServico.id &&
              $helper.verificaPermissao('imprimir-ordem-servico')
          "
          color="default"
          outlined
          class="ml-1 mr-1"
          @click="modalImpressaoOS = true"
          >Imprimir</v-btn
        >
        <v-btn
          color="primary"
          outlined
          v-if="
            getOrdemServico.id &&
              $helper.verificaPermissao('pagamento-ordem-servico') &&
              !getOrdemServico.pago
          "
          @click="setModalPagamentoOrdemServico(true)"
          class="ml-1 mr-1"
          >Pagamento</v-btn
        >
        <v-btn
          color="error"
          outlined
          v-if="
            getOrdemServico.id &&
              $helper.verificaPermissao('excluir-ordem-servico')
          "
          @click="setModalExcluirOrdemServico(true)"
          class="ml-1 mr-1"
          >Excluir</v-btn
        >
        <v-menu bottom left transition="slide-y-transition" class="ml-10 mr-10">
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon v-bind="attrs" v-on="on">
              <v-icon>mdi-dots-vertical</v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-list-item @click="cadastrarProduto()">
              <v-list-item-action>
                <v-icon>window</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>Cadastrar Serviço</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item @click="setModalHistoricoStatusOS(true)">
              <v-list-item-action>
                <v-icon>menu_book</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>Histórico Status</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            
          </v-list>
        </v-menu>
      </v-card-title>
      <v-card-title>
        <v-tabs app grow v-model="tabs" class="hidden-sm-and-down">
          <v-tab>
            <span>DADOS GERAIS</span>
          </v-tab>

          <v-tab v-if="getOrdemServico.id">
            <span>REGISTROS DE ATIVIDADES</span>
          </v-tab>
        </v-tabs>
      </v-card-title>

      <v-card-text>
        <v-tabs-items v-model="tabs" class="pa-8">
          <v-tab-item>
            <v-card outlined v-if="getOrdemServico.status != 'CONCLUÍDO'">
              <v-card-title> <h5>Inserir Serviço</h5> </v-card-title>

              <v-card-text class="mb-0 pb-0">
                <v-form class="px-3" ref="formServico">
                  <v-layout row wrap>
                    <v-flex xs12 md12> </v-flex>
                    <v-flex xs12 md7>
                      <v-autocomplete
                        :items="getProdutos"
                        :rules="rules.servico_descricao"
                        v-model="servicoSelecionado"
                        label="Serviço"
                        item-text="descricao"
                        item-value="id"
                        outlined
                        dense
                        return-object
                        class="ml-1 mr-1"
                        @click="$event.target.select()"
                        id="servico_descricao"
                        @keyup.enter="focusInput('servico_preco')"
                      ></v-autocomplete>
                    </v-flex>
                    <v-flex xs12 md1>
                      <v-text-field
                        v-model="precoVendaSelecionado"
                        label="Preço Unit."
                        outlined
                        dense
                        class="ml-1 mr-1"
                        @input="calculaTotal()"
                        v-mask="[
                          '#,##',
                          '##,##',
                          '###,###',
                          '#.###,##',
                          '##.###,##',
                          '###.###,##',
                        ]"
                        @click="$event.target.select()"
                        id="servico_preco"
                        @keyup.enter="focusInput('servico_quantidade')"
                        :rules="rules.servicoDescricao"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 md1>
                      <v-text-field
                        v-model="servicoSelecionado.quantidade"
                        label="Quantidade"
                        outlined
                        dense
                        class="ml-1 mr-1"
                        @input="calculaTotal()"
                        v-mask="[
                          '#,##',
                          '##,##',
                          '###,###',
                          '#.###,##',
                          '##.###,##',
                          '###.###,##',
                        ]"
                        @click="$event.target.select()"
                        id="servico_quantidade"
                        @keyup.enter="focusInput('servico_desconto')"
                        :rules="rules.servico_quantidade"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 md1>
                      <v-text-field
                        v-model="subtotalSelecionado"
                        label="Subtotal"
                        outlined
                        dense
                        class="ml-1 mr-1"
                        readonly
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 md1>
                      <v-text-field
                        v-model="servicoSelecionado.desconto"
                        label="Desconto"
                        outlined
                        dense
                        class="ml-1 mr-1"
                        @input="calculaTotal()"
                        v-mask="[
                          '#,##',
                          '##,##',
                          '###,###',
                          '#.###,##',
                          '##.###,##',
                          '###.###,##',
                        ]"
                        @click="$event.target.select()"
                        id="servico_desconto"
                        @keyup.enter="addServico()"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 md1>
                      <v-text-field
                        v-model="totalSelecionado"
                        label="Total"
                        outlined
                        dense
                        class="ml-1 mr-1"
                        append-outer-icon="control_point"
                        @click:append-outer="addServico()"
                        readonly
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-form>
              </v-card-text>
            </v-card>

            <v-layout row wrap class="px-3">
              <v-flex xs12 md8>
                <v-card outlined class="mt-2">
                  <v-card-title>
                    <h5>Serviços</h5>
                  </v-card-title>
                  <v-card-text>
                    <v-simple-table dense>
                      <template v-slot:default>
                        <thead>
                          <tr>
                            <th width="5%">Cód.</th>
                            <th>Serviço</th>
                            <th width="5%">Subtotal</th>
                            <th width="5%">Quantidade</th>
                            <th width="5%">Desconto</th>
                            <th width="5%">Total</th>
                            <th width="5%"></th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="i in servicos" :key="i.servico_id">
                            <td width="5%">{{ i.servico_id }}</td>
                            <td>{{ i.descricao }}</td>
                            <td width="5%">{{ i.subtotal }}</td>
                            <td width="5%">{{ i.quantidade }}</td>
                            <td width="5%">{{ i.desconto }}</td>
                            <td width="5%">{{ i.total }}</td>
                            <td>
                              <v-btn
                                x-small
                                color="error"
                                @click="removerServico(i)"
                                outlined
                              >
                                <v-icon>delete_forever</v-icon>
                              </v-btn>
                            </td>
                          </tr>
                          <tr>
                            <td colspan="5" align="right">
                              <strong>SUBTOTAL</strong>
                            </td>
                            <td>{{ getOrdemServico.subtotal }}</td>
                            <td></td>
                          </tr>
                          <tr>
                            <td colspan="5" align="right">
                              <strong>DESCONTO</strong>
                            </td>
                            <td>{{ getOrdemServico.desconto }}</td>
                            <td></td>
                          </tr>
                          <tr>
                            <td colspan="5" align="right">
                              <strong>TOTAL</strong>
                            </td>
                            <td>{{ getOrdemServico.total }}</td>
                            <td></td>
                          </tr>
                        </tbody>
                      </template>
                    </v-simple-table>
                  </v-card-text>
                </v-card>
                <v-card class="mt-2" outlined>
                  <v-card-title>
                    <h5>Cliente</h5>
                  </v-card-title>
                  <v-card-text>
                    <v-form class="px-3">
                      <v-layout row wrap>
                        <v-flex xs12 md10>
                          <v-autocomplete
                            :items="getContatos"
                            v-model="cliente"
                            label="Cliente"
                            item-text="nome"
                            item-value="id"
                            outlined
                            dense
                            return-object
                            append-icon="control_point"
                            @click:append="cadastrarContato()"
                            @click="$event.target.select()"
                            class="ml-1 mr-1"
                          ></v-autocomplete>
                        </v-flex>
                        <v-flex xs12 md2>
                          <v-autocomplete
                            :items="getFuncionarios"
                            v-model="getOrdemServico.tecnico_id"
                            label="Técnico"
                            item-text="nome_abreviado"
                            item-value="id"
                            outlined
                            dense
                            class="ml-1 mr-1"
                          ></v-autocomplete>
                        </v-flex>
                        <v-flex xs12 md3>
                          <v-text-field
                            v-model="getOrdemServico.cep"
                            label="CEP"
                            outlined
                            dense
                            v-mask="'#####-###'"
                            class="ml-1 mr-1"
                            @blur="pesquisaCep()"
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs12 md6>
                          <v-text-field
                            v-model="getOrdemServico.logradouro"
                            label="Logradouro"
                            outlined
                            dense
                            class="ml-1 mr-1"
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs12 md3>
                          <v-text-field
                            v-model="getOrdemServico.numero"
                            label="Número"
                            outlined
                            dense
                            class="ml-1 mr-1"
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs12 md4>
                          <v-text-field
                            v-model="getOrdemServico.bairro"
                            label="Bairro"
                            outlined
                            dense
                            class="ml-1 mr-1"
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs12 md4>
                          <v-text-field
                            v-model="getOrdemServico.cidade"
                            label="Cidade"
                            outlined
                            dense
                            class="ml-1 mr-1"
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs12 md4>
                          <v-text-field
                            v-model="getOrdemServico.estado"
                            label="Estado"
                            outlined
                            dense
                            class="ml-1 mr-1"
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs12 md4>
                          <v-text-field
                            v-model="getOrdemServico.telefone"
                            label="Telefone"
                            outlined
                            dense
                            class="ml-1 mr-1"
                            v-mask="'(##) #####-####'"
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs12 md4>
                          <v-text-field
                            v-model="getOrdemServico.celular_1"
                            label="Celular"
                            outlined
                            dense
                            class="ml-1 mr-1"
                            v-mask="'(##) #####-####'"
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs12 md4>
                          <v-text-field
                            v-model="getOrdemServico.whatsapp"
                            label="WhatsApp"
                            outlined
                            dense
                            class="ml-1 mr-1"
                            v-mask="'(##) #####-####'"
                          ></v-text-field>
                        </v-flex>
                      </v-layout>
                    </v-form>
                  </v-card-text>
                </v-card>
              </v-flex>
              <v-flex xs12 md4>
                <v-card class="mt-2 ml-1" outlined>
                  <v-card-title>
                    <h5>Prazo e Observações</h5>
                  </v-card-title>
                  <v-card-text class="mb-0 pb-0">
                    <v-layout row wrap>
                      <v-flex xs12 md6>
                        <v-text-field
                          label="Data Início"
                          v-model="getOrdemServico.data_inicio"
                          class="ml-1 mr-1"
                          outlined
                          dense
                          type="date"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 md6>
                        <v-text-field
                          label="Data Fim"
                          v-model="getOrdemServico.data_fim"
                          class="ml-1 mr-1"
                          outlined
                          dense
                          type="date"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 md12>
                        <v-text-field
                          v-model="getOrdemServico.informacoes_garantia"
                          label="Garantia"
                          outlined
                          dense
                          class="ml-1 mr-1"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 md6>
                        <v-select
                          :items="[
                            'EM ABERTO',
                            'EM ANDAMENTO',
                            'CONCLUÍDO',
                            'CANCELADO',
                          ]"
                          v-model="getOrdemServico.status"
                          label="Status"
                          outlined
                          dense
                          class="mr-1 ml-1"
                        ></v-select>
                      </v-flex>
                      <v-flex xs12 md6>
                        <v-text-field
                          label="Pagamento"
                          id="id"
                          :value="
                            `${
                              getOrdemServico.pago
                                ? 'EFETUADO'
                                : 'AGUARDANDO PAGAMENTO'
                            }`
                          "
                          outlined
                          dense
                          class="ml-1 mr-1"
                          readonly
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 md12>
                        <v-text-field
                          label="Referência"
                          v-model="getOrdemServico.referencia"
                          outlined
                          dense
                          class="ml-1 mr-1"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 md12>
                        <v-textarea
                          v-model="getOrdemServico.observacao"
                          label="Observações"
                          outlined
                          dense
                          class="ml-1 mr-1"
                        ></v-textarea>
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                  <!-- <v-card-title class="ma-0 mt-0">
                    <h5>Tanque</h5>
                  </v-card-title>
                  <v-card-text>
                    <v-layout row wrap>
                      <v-select
                        :items="['', ...getModelosTanques]"
                        item-value="id"
                        item-text="modelo"
                        outlined
                        dense
                        v-model="modeloTanqueSelecionado"
                        label="Modelo do Tanque"
                        return-object
                        class="ml-1 mr-1"
                      ></v-select>
                      <v-flex xs12 md12>
                        <v-row justify="space-around" class="ml-3 mr-3 mb-3">
                          <v-img
                            :src="modeloTanqueSelecionado.foto_url"
                            aspect-ratio="2.0"
                            contain
                            v-if="modeloTanqueSelecionado.foto_url"
                            max-width="250"
                          ></v-img>
                        </v-row>
                      </v-flex>
                    </v-layout>
                  </v-card-text> -->
                </v-card>
                <v-card v-if="getOrdemServico.formas_pagamento && getOrdemServico.formas_pagamento.length > 0" outlined class="mt-2 ml-1">
                  <v-card-title>
                    <h5>Formas de Pagamento</h5>
                  </v-card-title>
                  <v-card-text>
                    <v-simple-table dense>
                      <template v-slot:default>
                        <thead>
                          <tr>
                            <th>Forma</th>
                            <th>Valor</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="fp in getOrdemServico.formas_pagamento" :key="fp.id">
                            <td>{{fp.forma}}</td>
                            <td>{{$helper.formatReal(parseFloat(fp.valor_pago))}}</td>
                          </tr>
                        </tbody>
                      </template>
                    </v-simple-table>
                  </v-card-text>
                </v-card>
              </v-flex>
            </v-layout>
          </v-tab-item>
          <v-tab-item>
            <v-card-title>
              <v-spacer></v-spacer>

              <v-btn color="success" outlined @click="cadastrarAtividadeOs()"
                >Registrar</v-btn
              >
            </v-card-title>
            <AtividadeListar />
          </v-tab-item>
        </v-tabs-items>
      </v-card-text>
    </v-card>
    <v-dialog
      v-model="modalSalvarOrdemServico"
      persistent
      max-width="500px"
      transition="dialog-transition"
    >
      <v-card>
        <v-card-title>Salvar</v-card-title>
        <v-card-text>
          <h3 align="center">Tem certeza que deseja salvar?</h3>
        </v-card-text>
        <v-card-actions>
          <v-btn
            color="defualt"
            @click="modalSalvarOrdemServico = false"
            outlined
            >VOLTAR</v-btn
          >
          <v-spacer></v-spacer>
          <v-btn color="success" outlined @click="_salvarOrdemServico()"
            >SIM</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="modalImpressaoOS"
      scrollable
      persistent
      max-width="500px"
      transition="dialog-transition"
    >
      <v-card>
        <v-card-title>
          Imprimir
        </v-card-title>
        <v-card-text>
          <v-flex xs12 md12>
            <v-btn
              color="primary"
              outlined
              block
              class="mt-2"
              @click="
                imprimirOrdemServico({
                  ...getOrdemServico,
                  modelo_impressao: 'A4',
                })
              "
              :loading="$store.getters.getOverlay"
              >Impressão A4</v-btn
            >
          </v-flex>
          <v-flex xs12 md12>
            <v-btn
              color="primary"
              outlined
              block
              class="mt-2 mb-2"
              @click="
                imprimirOrdemServico({
                  ...getOrdemServico,
                  modelo_impressao: 'CUPOM',
                })
              "
              :loading="$store.getters.getOverlay"
              >Impressão Cupom</v-btn
            >
          </v-flex>
          <!-- <v-flex xs12 md12>
                    <v-btn color="primary" outlined block class="mt-2 mb-2" @click="setModalInfoProposta(true)"
                        :loading="$store.getters.getOverlay">Impressão Proposta</v-btn>
                </v-flex> -->
        </v-card-text>
        <v-card-actions>
          <v-btn
            color="default"
            @click="modalImpressaoOS = false"
            outlined
            block
            >Voltar</v-btn
          >
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
   
    <ModalCadastroContato v-if="getModalCadastroContato" />
    <ModaHistoricoStatusOS />
    <ModalPagamento />
    <ModalExcluir />
    <ModalCadastroProduto v-if="getModalCadastroProduto" />
  </v-dialog>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import ModalCadastroContato from "@/pages/contato/ModalCadastro";
import ModaHistoricoStatusOS from "@/pages/ordemServico/ModalHistoricoStatus";
import ContatoService from "@/services/ContatoService";
import AtividadeListar from "@/pages/ordemServico/atividade/Listar";
import ModalPagamento from "@/pages/ordemServico/ModalPagamento";
import ModalExcluir from "@/pages/ordemServico/ModalExcluir";
import ModalCadastroProduto from "@/pages/produto/ModalCadastro";

export default {
  components: {
    ModalCadastroContato,
    ModaHistoricoStatusOS,
    AtividadeListar,
    ModalPagamento,
    ModalExcluir,
    ModalCadastroProduto,
  },
  data() {
    return {
      servicoSelecionado: {},
      subtotalSelecionado: "0,00",
      subtotalSelecionado: "0,00",
      precoVendaSelecionado: "0,00",
      totalSelecionado: "0,00",
      servicos: [],
      cliente: {},
      modalSalvarOrdemServico: false,
      modeloTanqueSelecionado: {},
      status: "",
      tabs: 0,
      exibeBotaoSalvar: true,
      rules: {
        servico_descricao: [(v) => !!v || "Campo obrigatório."],
        servico_preco_unitario: [(v) => !!v || "Campo obrigatório."],
        servico_quantidade: [(v) => !!v || "Campo obrigatório."],
      },
      modalImpressaoOS: false,
    };
  },
  watch: {
    servicoSelecionado() {
      let servico = { ...this.servicoSelecionado };
      this.subtotalSelecionado = this.$helper.formatReal(
        parseFloat(servico.preco_venda * 1)
      );
      this.servicoSelecionado.quantidade = "1,00";
      this.precoVendaSelecionado = this.$helper.formatReal(
        parseFloat(servico.preco_venda)
      );
      this.servicoSelecionado.desconto = "0,00";
      this.totalSelecionado = this.subtotalSelecionado;
    },
    cliente() {
      ContatoService.editar(this.cliente.id).then((res) => {
        this.getOrdemServico.cep = res.data.cep;
        this.getOrdemServico.logradouro = res.data.logradouro;
        this.getOrdemServico.numero = res.data.numero;
        this.getOrdemServico.bairro = res.data.bairro;
        this.getOrdemServico.cidade = res.data.cidade;
        this.getOrdemServico.estado = res.data.uf;
        this.getOrdemServico.telefone = res.data.telefone;
        this.getOrdemServico.celular_1 = res.data.celular1;
        this.getOrdemServico.whatsapp = res.data.whatsapp;
      });
      // }
    },
    getModalCadastroOrdemServico() {
      this.exibeBotaoSalvar = true;
      if (this.getModalCadastroOrdemServico == false) {
        this.servicos = [];
        this.modeloTanqueSelecionado = {};
        this.cliente = { id: "" };
        this.$store.commit("setAtividadesOs", []);
      }

      if (
        this.getModalCadastroOrdemServico == true &&
        this.getOrdemServico.id
      ) {
        this.listarAtividadeOs(this.getOrdemServico);
        this.getOrdemServico.servicos.map((o) => {
          this.servicos.push({
            descricao: o.descricao,
            subtotal: this.$helper.formatReal(parseFloat(o.subtotal)),
            quantidade: this.$helper.formatReal(parseFloat(o.quantidade)),
            desconto: this.$helper.formatReal(parseFloat(o.desconto)),
            total: this.$helper.formatReal(parseFloat(o.total)),
            servico_id: o.servico_id,
          });
        });

        this.cliente.id = this.getOrdemServico.cliente_id;
        // this.status = this.getOrdemServico.status;
        this.modeloTanqueSelecionado.id = this.getOrdemServico.modelo_tanque_id
          ? this.getOrdemServico.modelo_tanque_id
          : "";
        this.modeloTanqueSelecionado.foto_path = this.getOrdemServico
          .modelo_tanque
          ? this.getOrdemServico.modelo_tanque.foto_path
          : "";
        this.modeloTanqueSelecionado.foto_url = this.getOrdemServico
          .modelo_tanque
          ? this.getOrdemServico.modelo_tanque.foto_url
          : "";

        if (this.getOrdemServico.status == "CONCLUÍDO") {
          this.exibeBotaoSalvar = false;
        }
      }
    },
  },
  computed: {
    ...mapGetters([
      "getProdutos",
      "getFuncionarios",
      "getContatos",
      "getModalCadastroOrdemServico",
      "getOrdemServico",
      "getModalCadastroContato",
      "getModeloTanque",
      "getModelosTanques",
      "getModalCadastroProduto"
    ]),
  },
  methods: {
    ...mapActions([
      "listarContatos",
      // "listarFuncionarios",
      "listarServicos",
      "setModalCadastroOrdemServico",
      "cadastrarContato",
      "buscarContato",
      "salvarOrdemServico",
      "imprimirOrdemServico",
      "setModalExcluirOrdemServico",
      "atualizarOrdemServico",
      "setModalHistoricoStatusOS",
      "listarModeloTanque",
      "cadastrarAtividadeOs",
      "listarAtividadeOs",
      "setModalPagamentoOrdemServico",
      "cadastrarProduto"
    ]),
    _salvarOrdemServico() {
      this.modalSalvarOrdemServico = false;
      this.getOrdemServico.servicos = this.servicos;
      this.getOrdemServico.cliente_id = this.cliente.id;
      // this.getOrdemServico.status = this.status;
      if (this.modeloTanqueSelecionado != "") {
        this.getOrdemServico.modelo_tanque_id = this.modeloTanqueSelecionado.id;
      }
      if (this.getOrdemServico.id) {
        this.atualizarOrdemServico(this.getOrdemServico).then((res) => {
          if (this.getOrdemServico.status == "CONCLUÍDO") {
            this.exibeBotaoSalvar = false;
          }
        });
      } else {
        this.salvarOrdemServico(this.getOrdemServico).then((res) => {
          if (this.getOrdemServico.status == "CONCLUÍDO") {
            this.exibeBotaoSalvar = false;
          }
        });
      }
    },
    addServico() {
      if (this.$refs.formServico.validate() == false) {
        return;
      }
      if (!this.servicoSelecionado.id) {
        this.$store.commit("snackbarError", "Informe um serviço.");
      }

      let servico = {
        ...this.servicoSelecionado,
        subtotal: this.precoVendaSelecionado,
        servico_id: this.servicoSelecionado.id,
        total: this.totalSelecionado,
        desconto : this.servicoSelecionado.desconto != '' ? this.servicoSelecionado.desconto : '0,00'
      };

      this.servicos.push(servico);

      this.getOrdemServico.subtotal = this.$helper.formatReal(
        parseFloat(
          this.$helper.cleanFormatReal(this.getOrdemServico.subtotal) +
            this.$helper.cleanFormatReal(servico.subtotal) *
              this.$helper.cleanFormatReal(this.servicoSelecionado.quantidade)
        )
      );
      this.getOrdemServico.desconto =  this.$helper.formatReal(
        parseFloat(
          this.$helper.cleanFormatReal(this.getOrdemServico.desconto) +
            this.$helper.cleanFormatReal(servico.desconto)
        )
      )
      
      this.getOrdemServico.total = this.$helper.formatReal(
        parseFloat(
          this.$helper.cleanFormatReal(this.getOrdemServico.total) +
            this.$helper.cleanFormatReal(servico.total)
        )
      );

      this.$nextTick(() => {
        this.servico = "";

        this.servicoSelecionado = {
          quantidade: "1,00",
          preco_venda: 0,
        };
        this.focusInput("servico_descricao");
      });
    },
    removerServico(i) {
      let index = this.servicos.map((x) => x).indexOf(i);
      this.servicos.splice(index, 1);

      this.getOrdemServico.subtotal = this.$helper.formatReal(
        parseFloat(
          this.$helper.cleanFormatReal(this.getOrdemServico.subtotal) -
            (this.$helper.cleanFormatReal(i.subtotal) * this.$helper.cleanFormatReal(i.quantidade)) 
            // this.$helper.cleanFormatReal(i.total)
        )
      );
      this.getOrdemServico.desconto = this.$helper.formatReal(
        parseFloat(
          this.$helper.cleanFormatReal(this.getOrdemServico.desconto) -
            this.$helper.cleanFormatReal(i.desconto)
        )
      );

      this.getOrdemServico.total = this.$helper.formatReal(
        parseFloat(
          this.$helper.cleanFormatReal(this.getOrdemServico.total) -
            this.$helper.cleanFormatReal(i.total)
        )
      );
    },
    calculaTotal() {
      let preco_venda = this.$helper.cleanFormatReal(
        this.precoVendaSelecionado
      );
      let quantidade = this.$helper.cleanFormatReal(
        this.servicoSelecionado.quantidade
      );

      

      if(preco_venda > 0 && this.servicoSelecionado.desconto != ''){
        this.subtotalSelecionado =
          isNaN(preco_venda) || isNaN(quantidade)
            ? "0,00"
            : this.$helper.formatReal(parseFloat(preco_venda * quantidade));

        this.totalSelecionado = this.$helper.formatReal(
          parseFloat(
            this.$helper.cleanFormatReal(this.subtotalSelecionado) -
              this.$helper.cleanFormatReal(this.servicoSelecionado.desconto)
          )
        );
      }

    },
    pesquisaCep() {
      this.$store.commit("setOverlay", true);
      this.$http
        .get(`https://viacep.com.br/ws/${this.getOrdemServico.cep}/json/`)
        .then((res) => {
          this.$store.commit("setOverlay", false);
          this.getOrdemServico.logradouro = res.data.logradouro;
          this.getOrdemServico.bairro = res.data.bairro;
          this.getOrdemServico.cidade = res.data.localidade;
          this.getOrdemServico.estado = res.data.uf;
          this.getOrdemServico.codigo_municipio = res.data.ibge;
          this.getOrdemServico.tipo = this.tipo;
          document.getElementById("numero").focus();
          // let indexCidade = this.getCidades
          //   .map((i) => i.codigo)
          //   .indexOf(res.data.ibge);
          // this.cidadeSelecionada = this.getCidades[indexCidade];
        })
        .catch((e) => {
          console.log(e);
          this.$store.commit("setOverlay", false);
        });
    },
    focusInput(idInput) {
      document.getElementById(`${idInput}`).focus();
    },
  },
  created() {
    this.listarServicos();
    // this.listarFuncionarios();
    this.listarContatos({});
    // this.listarModeloTanque();
  },
};
</script>
